import { canFilter } from '../../mixins/can_filter';
import { canPaginate } from '../../mixins/can_paginate';
import { NEW_ADMIN_URL } from 'environment';

import './broadcasts.scss';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/broadcasts', {
        template: require('./broadcasts.html'),
        controller: 'BroadcastsController'
    });
})
.controller('BroadcastsController', function($scope, $location, Broadcast) {
    canFilter($scope, $location);
    canPaginate($scope, $location);
    $scope.s || ($scope.s = 'starts_at');
    $scope.newAdminURL = NEW_ADMIN_URL;

    const params = _.pick($scope, 'q', 's', 'p');

    const query = $location.search();

    $scope.timeframe = query.timeframe || 'all';
    switch ($scope.timeframe) {
    case 'today':
        const todayRange = (new Date()).todayRangeUTC();
        params.q = `+starts_at:[${todayRange.from} TO ${todayRange.to}] ${params.q || ''}`.trim();
        break;
    case 'specific_date':
        const ms = Date.parse(query.specific_date);
        if (!isNaN(ms)) {
            $scope.specific_date = new Date(ms);
            const dayRange = $scope.specific_date.rangeUTC();
            const dayRangeQuery = `[${dayRange.from} TO ${dayRange.to}]`;
            params.q = `+starts_at:${dayRangeQuery} ${params.q || ''}`.trim();
        }
        break;
    case 'upcoming':
        params.q = `+timeframe:future ${params.q || ''}`.trim();
        break;
    case 'recent':
        params.q = `+timeframe:relevant ${params.q || ''}`.trim();
        break;
    }

    $scope.setTimeframe = (t) => {
      var params = {timeframe: t, p: 0, f: $scope.getFilterParam(), s: $scope.s, q: query.q};
      if (t == 'recent') {
        params.s = '-starts_at';
      } else if (t == 'upcoming') {
        params.s = 'starts_at';
      }
      $location.search(params);
    };

    $scope.filterDate = (date) => {
      $location.search({
        timeframe: 'specific_date',
        specific_date: date,
        p: 0,
        f: $scope.getFilterParam(),
        s: $scope.s,
      });
    };

    if (!$scope.f.include_archived) {
        params['filter.include_archived'] = 'false';
    }

    if ($scope.f.account && $scope.f.account.active) {
        params['filter.account_id'] = $scope.f.account.id;
    }

    if ($scope.f.recurrence && $scope.f.recurrence.active) {
        params['filter.recurrence_id'] = $scope.f.recurrence.id;
    }

    params.include_stream_diagnostics = true;

    $scope.loading = true;
    $scope.broadcasts = Broadcast.query(params, function(data, getResponseHeader) {
        const pagination = getResponseHeader('X-Pagination');
        $scope.pagination = (pagination ? JSON.parse(pagination) : {});
        return $scope.loading = false;
    });
});


// WEBPACK FOOTER //
// ./views/broadcasts/broadcasts_controller.js